import React, {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from "redux";
import classNames from 'classnames'
import {Grid, Typography, withStyles} from '@material-ui/core'
import MainPaper from '../../../../component/MainPaper'
import OfflinePaymentForm from '../../components/OfflinePaymentForm'
import PaymentSummary from '../../../../shared/components/PaymentSummary'
import PaymentButtons from '../../../../shared/components/PaymentButtons'
import {OfflinePaymentFormActions} from "../../actions"
import {GenericPaymentActions} from "../../../../shared/actions"
import Main from "../../../../container/Main"
import {doPaymentRequest, getOfflinePaymentRequestJson} from "../../../../helpers"
import styles from './styles'

/**
 * Content section representing the Offline Payment Form hoster.
 */
class OfflinePayment extends Component {
    onSubmit = (e) => {
      e.preventDefault()
      const data = getOfflinePaymentRequestJson(this.props.formData, this.props.paymentData, this.props.offlineFormData)
      doPaymentRequest(data, this.props, 'offline-feedback')
    }

    /**
     * Renders the Offline Payment section containing the Offline Payment Form.
     *
     * @returns JSX structure defining the visual representation of the Offline Payment Content Section.
     */
    render() {
        const {
            classes,
            paymentData,
            formData,
            hasErrors,
            onSubmit,
            queryString
        } = this.props

        return (
            <form
                id="payment-form"
                method="POST"
                onSubmit={this.onSubmit}
                action="./payments"
                className={classNames(
                    classes.containerForm
                )}>

                <Grid container style={{marginTop: 11, paddingTop: 19}} justify="space-between" alignItems="center">
                    <Grid item xs={12} sm={8}>
                        <Typography variant={"subtitle1"} className={classes.paymentDeviceSubtitle}>
                            Medio de pago seleccionado para la compra
                        </Typography>
                    </Grid>

                    <Grid item xs={12} sm={4} className={classes.paymentMeanLogoContainer}>
                        <img alt="" src={`${window.env.ASSETS_URL}/images/cards/${paymentData.cardLogo}.svg`}
                                className={classes.paymentMeanLogo}/>
                    </Grid>
                </Grid>


                <MainPaper
                    isOffline={true}
                    after={
                        <PaymentButtons hasErrors={hasErrors}
                                        onSubmit={onSubmit}
                                        cancelUrl={formData.cancelUrl}
                                        submitButtonText="Generar comprobante"/>
                    }
                    footer={
                        <PaymentSummary amount={paymentData.amount}
                                        currency={paymentData.currency}/>
                    }>

                    <Typography variant="subtitle1" className={classes.subtitle}>Datos personales</Typography>

                    <OfflinePaymentForm apikey={queryString.apikey} consumerUsername={formData.consumerUsername} />

                </MainPaper>
            </form>
        )
    }
}

function mapStateToProps(state) {
    return {
        offlineFormData: state.offlinePaymentForm,
        formData: state.forms.formData,
        paymentData: state.forms.paymentData,
        hasErrors: state.offlinePaymentForm.hasErrors
    }
}

function mapDispatchToProps(dispatch) {
    return {actions: bindActionCreators({ ...OfflinePaymentFormActions, ...GenericPaymentActions}, dispatch)}
}

const Styled = withStyles(styles)(OfflinePayment)
const DataBound = connect(mapStateToProps, mapDispatchToProps)(Styled)

export default Main(DataBound)
